import { Stack as MuiStack, StackProps as MuiStackProps } from '@mui/material';

export type { MuiStackProps as FlexProps };

const Flex = MuiStack;

export default Flex;
